import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
    continue_processing_goods_received: { status: "idle" },
};

export const continue_processing_goods_received_Slice = createSlice({
    name: "continue_processing_goods_received",
    initialState,
    reducers: {
        success_continue_processing_goods_received: (state, action) => {
            state.continue_processing_goods_received = { status: app_consts.SUCCESS, data: action.payload };
        },
        fail_continue_processing_goods_received: (state, action) => {
            state.continue_processing_goods_received = { status: app_consts.FAIL, message: action.payload };
        },
        reset_continue_processing_goods_received: (state) => {
            state.continue_processing_goods_received = { status: app_consts.IDLE };
        },
        loading_continue_processing_goods_received: (state) => {
            state.continue_processing_goods_received = { status: app_consts.LOADING };
        },
    }
});

export const { success_continue_processing_goods_received, fail_continue_processing_goods_received, reset_continue_processing_goods_received, loading_continue_processing_goods_received } = continue_processing_goods_received_Slice.actions;

export default continue_processing_goods_received_Slice.reducer;